module.exports = __webpack_public_path__ + "img/marker_doanhnghiep2.8557d0b9.png";